import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.$pointerBar = this.$('pointerBar')[0];
        this.$pointerCircle = this.$('pointerCircle')[0];
        this.$pointsBefore = this.$('pointBefore');
        this.$pointsAfter = this.$('pointAfter');
        this.$menuLetters = this.$('menuLetter');

        this.timeline = new gsap.timeline({repeat: -1});
        
        this.timeline.staggerFromTo(this.$menuLetters,1,{
            alpha: 0,
        }, {
            alpha: 1,
        }, 0.1);

        this.pointerCircleAnim = gsap.fromTo(this.$pointerCircle,{
            scale: 0
        }, {
            scale: 1,
            duration: 1
        });
        this.timeline.add(this.pointerCircleAnim, "-=2");

        this.pointerBarAnim = gsap.fromTo(this.$pointerBar,{
            scaleY: 0
        }, {
            scaleY: 1,
            duration: 1
        });
        this.timeline.add(this.pointerBarAnim,"-=2.5");

        this.timeline.staggerFromTo(this.$pointsBefore,1,{
            scale: 0,
            y: "-50px"
        }, {
            scale: 1,
            y: 0,
        }, -0.1, "-=1.6");

        this.timeline.staggerFromTo(this.$pointsAfter,1,{
            scale: 0,
            y: "-50px"
        }, {
            scale: 1,
            y: 0,
        }, 0.1, "-=1.6");

        this.timeline.pause();

    }

    progress({progress, isReversed}) {
        let relativeProgress = progress;
        if(isReversed) relativeProgress = 1-progress;
        
        if(this.timeline != undefined) {
            this.timeline.progress(relativeProgress);
        }
    }
}
